// extracted by mini-css-extract-plugin
export default {"messagesContainer":"MsgState_messagesContainer__9pYT-","conversationContainer":"MsgState_conversationContainer__tvSX9"};